/**
 * Round 95 — Return-to pill.
 *
 * Renders a small "Return to Dashboard" (or caller-supplied)
 * button in a bot page header when the page was launched via a
 * Round 94 deep link (i.e. `?return_to=…` present in the URL).
 *
 * Zero visible artifact when no return_to param — pre-Round-94
 * pages that opened directly are unchanged.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import useDeepLinkParams from '@/hooks/useDeepLinkParams';

const KNOWN_RETURN_LABELS = {
  '/dashboard': 'Return to Dashboard',
  '/scheduler': 'Return to Weekly Planner',
  '/ask-paygbot': 'Return to Ask PayGBot',
  '/notifications': 'Return to Notifications',
};

const ReturnToDashboardPill = ({ className = '', testId = 'return-to-pill' }) => {
  const navigate = useNavigate();
  const { return_to } = useDeepLinkParams();

  if (!return_to) return null;

  const label = KNOWN_RETURN_LABELS[return_to] || 'Return';

  return (
    <button
      type="button"
      onClick={() => navigate(return_to)}
      className={
        'inline-flex items-center gap-2 px-3 py-1.5 rounded-full '
        + 'bg-white/60 border border-neutral-200 text-sm font-medium '
        + 'text-neutral-700 hover:bg-white hover:border-neutral-300 '
        + 'transition-colors '
        + className
      }
      data-testid={testId}
      data-return-to={return_to}
    >
      <ArrowLeft weight="bold" className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
};

export default ReturnToDashboardPill;
